import PropTypes from 'prop-types'
import theme from '../../constants/theme'

const ErrorIcon = ({ color = theme.danger, style, ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={2.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ width: '45%', height: '45%', color, ...style }}
    {...props}
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="15" y1="9" x2="9" y2="15" />
    <line x1="9" y1="9" x2="15" y2="15" />
  </svg>
)

ErrorIcon.propTypes = {
  color: PropTypes.string,
  style: PropTypes.object,
}

export default ErrorIcon
